module.exports = __webpack_public_path__ + "img/add_account.891c4ba9.png";